const ArticlePageTitle = () => {
	return (
		<>
		<div class="display-3">Articles</div>
		<div class="fs-2">Learn why sustainability matters</div>
		</>
		
	)
}

export default ArticlePageTitle